import React from 'react';
import PropTypes from 'prop-types';

export const DarkMode = ({ width, height, ...props }) => (
  <svg
    data-icon='dark-mode'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12.1 22c-1.4 0-2.713-.267-3.938-.8a10.279 10.279 0 0 1-3.2-2.162 10.279 10.279 0 0 1-2.162-3.2A9.756 9.756 0 0 1 2 11.9c0-2.433.775-4.58 2.325-6.438C5.875 3.605 7.85 2.45 10.25 2a10.1 10.1 0 0 0 .275 4.838 9.867 9.867 0 0 0 2.5 4.137 9.867 9.867 0 0 0 4.138 2.5A10.1 10.1 0 0 0 22 13.75c-.433 2.4-1.583 4.375-3.45 5.925C16.683 21.225 14.533 22 12.1 22Zm0-2a7.912 7.912 0 0 0 4.075-1.1 7.914 7.914 0 0 0 2.95-3.025 12.403 12.403 0 0 1-4.075-1.088 11.884 11.884 0 0 1-3.45-2.412 12.087 12.087 0 0 1-2.425-3.45A11.804 11.804 0 0 1 8.1 4.85a7.797 7.797 0 0 0-3.012 2.963A8.048 8.048 0 0 0 4 11.9c0 2.25.787 4.162 2.362 5.737C7.938 19.212 9.85 20 12.1 20Z'
    />
  </svg>
);

DarkMode.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

DarkMode.defaultProps = {
  width: 24,
  height: 24,
};
